export const ADMIN_USERS_SLICE_NAME = "adminUsers"
